import { Link, useLocation } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { HiMiniSquares2X2 } from "react-icons/hi2";
import { IoIosArrowDown } from "react-icons/io";
import UsersMultipleIcon from "../../icons/usersMultible";
import ManagerIcon from "../../icons/managerIcon";
import AnalyticsIcon from "../../icons/analyticsIcon";
import StoreIcon from "../../icons/storeIcon";
import ChartIcon from "../../icons/chartIcon";
import SettingsIcon from "../../icons/settingsIcon";
import { useTranslation } from "react-i18next";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { RxHamburgerMenu } from "react-icons/rx";
import SidebarLogo from "./assets/sidebarLogo.png";

const SideBar = ({ setOpen, open }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [openEmployees, setOpenEmployees] = useState(false);
  const subLinksRef = useRef(null);
  const [subLinksHeight, setSubLinksHeight] = useState(0);

  useEffect(() => {
    if (subLinksRef.current) {
      setSubLinksHeight(subLinksRef.current.scrollHeight);
    }
  }, [openEmployees]);

  const links = [
    {
      path: "/",
      label: t("dashboard"),
      Icon: HiMiniSquares2X2,
    },
    {
      path: "/members",
      label: t("members"),
      Icon: UsersMultipleIcon,
    },
    {
      path: "/employees",
      label: t("employees"),
      Icon: ManagerIcon,
      subLinks: [
        { path: "/employees/attendance", label: t("attendance") },
        { path: "/employees/salaries", label: t("salaries") },
        { path: "/employees/leaves", label: t("leaves") },
      ],
    },
    {
      path: "/activities",
      label: t("activities"),
      Icon: AnalyticsIcon,
    },
    {
      path: "/store",
      label: t("store"),
      Icon: StoreIcon,
    },
    {
      path: "/reports",
      label: t("reports"),
      Icon: ChartIcon,
    },
    { path: "/settings", label: t("settings"), Icon: SettingsIcon },
  ];

  return (
    <>
      {open && (
        <div
          className="fixed duration-500 top-0 md:hidden left-0 w-full h-full bg-[#00000094] z-[99999]"
          onClick={() => setOpen(false)}
        ></div>
      )}
      <aside
        className={`md:sticky z-[99999] fixed flex flex-col top-0 w-1/2 md:w-[200px] lg:w-64 min-h-screen bg-sideBar rtl:border-l  ltr:border-r transition-all duration-500 border-[#DBE0E7] ${
          open ? "rtl:right-0 ltr:left-0" : "rtl:-right-full ltr:-left-full"
        }`}
      >
        <RxHamburgerMenu
          size={24}
          className="mx-auto my-4 text-white cursor-pointer md:hidden"
          onClick={() => setOpen(!open)}
        />
        <Link
          to={"/"}
          className="border-b border-[#DBE0E74D] flex items-center justify-center font-bold text-[20px] text-primary"
        >
          <img src={SidebarLogo} alt="Sidebar Logo"
          // style={{ width: '4em', marginablock: '0.5em' }}
          className="sidebar-logo w-[4em] my-[0.5em]" />
        </Link>

        <div className="flex flex-col my-4 text-xs capitalize md:text-sm lg:text-base">
          {links.map(({ path, label, Icon, subLinks }) => {
            const isActive = pathname === path || pathname.startsWith(path + "/");
            const textColor = isActive
              ? "text-primary bg-[#B6934A26] !border-primary"
              : "text-[#D1D5DB] hover:text-primary/80 ";

            if (subLinks) {
              return (
                <div key={path} className="flex flex-col">
                  <Link
                    to={path}
                    onClick={() => setOpenEmployees(!openEmployees)}
                    className={`flex items-center py-4 px-4 rtl:border-r-4 ltr:border-l-4 border-transparent gap-2 font-medium w-full text-left ${textColor}`}
                  >
                    <span>
                      <Icon
                        className="size-5"
                        fill={isActive ? "#d1a855" : "#D1D5DB"}
                      />
                    </span>
                    <span className="-mb-[3px] flex-1 text-start">{label}</span>
                    <IoIosArrowDown
                      className={`transform transition-transform duration-300 ${
                        openEmployees ? "rotate-0" : "rtl:rotate-90 ltr:-rotate-90"
                      }`}
                    />
                  </Link>

                  <div
                    ref={subLinksRef}
                    className="flex flex-col overflow-hidden transition-all duration-300 ease-in-out "
                    style={{
                      maxHeight: openEmployees ? `${subLinksHeight}px` : "0px",
                    }}
                  >
                    {subLinks.map((sub) => {
                      const isSubActive = pathname === sub.path;
                      return (
                        <Link
                          key={sub.path}
                          to={sub.path}
                          className={`flex items-center py-3 px-6 gap-2 font-normal ${
                            isSubActive
                              ? "text-primary bg-[#B6934A26]"
                              : "text-[#D1D5DB] hover:text-primary/80"
                          }`}
                        >
                          {sub.label}
                        </Link>
                      );
                    })}
                  </div>
                </div>
              );
            }

            return (
              <Link
                key={path}
                to={path}
                className={`flex items-center py-4 rtl:pr-4 rtl:border-r-4 ltr:border-l-4 border-transparent ltr:pl-4 gap-2 font-medium ${textColor}`}
              >
                <span>
                  <Icon className="size-5" fill={isActive ? "#d1a855" : "#D1D5DB"} />
                </span>
                <span className="-mb-[3px]">{label}</span>
              </Link>
            );
          })}
        </div>

        <section className="border-t border-[#DBE0E74D] mt-auto py-8">
          <div className="flex items-center text-xs capitalize md:text-sm lg:text-base w-4/5 gap-2 p-3 mx-auto border justify-center text-white mainLinear border-[#D1A8554D] rounded-lg cursor-pointer">
            <RiLogoutCircleRLine className="-rotate-90 md:size-6 size-4" />
            {t("logout")}
          </div>
        </section>
      </aside>
    </>
  );
};

export default SideBar;
